import { FC, useMemo } from 'react';

import { FilterItem } from 'componets/ui/Filter/FilterItem';

import { FieldData, IFilterValues } from 'models';

import { useAppSelector, useTranslate } from 'hooks';

import Utils from 'utils/utils';

import { selectGlobals } from 'selectors';

const WORDS = ['interestRateText', 'projectTypeText', 'countryText', 'excludeInvestmentsText'];

interface PrimaryMarketFiltersFormProps {
	setFields: (changedFields: FieldData[], allFields?: FieldData[]) => void;
	values: IFilterValues;
}
export const PrimaryMarketFiltersForm: FC<PrimaryMarketFiltersFormProps> = ({
	setFields,
	values,
}) => {
	const globals = useAppSelector(selectGlobals);

	const { interestRateText, projectTypeText, countryText, excludeInvestmentsText } =
		useTranslate(WORDS);

	const typeOptions = useMemo(
		() =>
			globals.loanTypes?.map((item) => ({
				value: item.type,
				label: Utils.formatProjectType(item.type),
			})) || [],
		[globals.loanTypes],
	);

	const countryOptions = useMemo(
		() =>
			globals.countries
				?.filter((item) => item.active_originator)
				.map((item) => {
					return {
						label: item.label,
						value: item.id.toString(),
					};
				}) || [],
		[globals.countries],
	);

	return (
		<>
			<FilterItem title={interestRateText} isRange name="interestRate" />

			<FilterItem
				name="excludeMyInvestment"
				title={excludeInvestmentsText}
				isSwitch
				checked={!!+values?.excludeMyInvestment}
				onClick={(value) => {
					setFields([
						{
							name: ['excludeMyInvestment'],
							value: value ? Number(value).toString() : '',
						},
					]);
				}}
			/>

			<FilterItem title={projectTypeText} name="type" options={typeOptions} isCheckbox />

			<FilterItem title={countryText} name="country" options={countryOptions} isCheckbox />
		</>
	);
};
